var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('v-form-base',{ref:"form",staticClass:"no-col-gutters",attrs:{"model":_vm.targetRule,"schema":_vm.schema},on:{"input":_vm.onInput}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }